import {
  GET,
  FOR_SUBMIT,
  CLEAR,
  UPDATE,
  UPDATE_KITCHEN,
  UPDATE_KITCHEN_FOR_SUBMIT,
  EXPORT_MEAL_PLANS,
  QUERY_MEAL_PLANNER_LOCATIONS
} from '@hobs/constants/mealPlanner';
import { _fetch as fetchSecure } from '@hobs/utils/fetch';
import { actionCreator } from './utils/utils';

export const getServiceRequests = (
  dateFrom,
  dateTo,
  locationName = '',
  kitchenId = '',
  statementOfRequirementId = '',
  unitId = ''
) =>
  actionCreator(
    `MealPlanner/Preview?dateFrom=${dateFrom}&dateTo=${dateTo}&locationName=${locationName}&kitchenId=${kitchenId}&partyId=${statementOfRequirementId}&unitId=${unitId}`,
    GET
  );

export const getMealPlannerForSubmit = () =>
  actionCreator('MealPlanner/ForSubmit', FOR_SUBMIT);

export function clearMealPlanner() {
  return dispatch => {
    dispatch({ type: CLEAR.SUCCESS });
  };
}

export const updateServiceRequests = body =>
  actionCreator('MealPlanner', UPDATE, { body: body, method: 'POST' });

export const getServiceRequestKitchenForSubmit = locationName =>
  actionCreator(
    `MealPlanner/Kitchens?locationName=${encodeURIComponent(locationName)}`,
    UPDATE_KITCHEN_FOR_SUBMIT
  );

export const updateServiceRequestKitchen = (serviceRequestId, kitchenId) =>
  actionCreator(
    `MealPlanner/ServiceRequest/${serviceRequestId}/Kitchen/${kitchenId}`,
    UPDATE_KITCHEN,
    { method: 'PUT' }
  );

export function exportMealPlans(body) {
  return dispatch => {
    dispatch(request());
    return fetchSecure('MealPlanner/ExportToExcel', {
      body,
      method: 'POST',
      forceBlob: true
    })
      .then(response => {
        if (response) {
          dispatch(success());
          return { success: true, blob: response };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: EXPORT_MEAL_PLANS.REQUEST };
  }
  function success() {
    return { type: EXPORT_MEAL_PLANS.SUCCESS };
  }
  function failure(error) {
    return { type: EXPORT_MEAL_PLANS.FAILURE, error };
  }
}

export const queryLocationsForMealPlanner = query =>
  actionCreator(
    `MealPlanner/Locations?locationName=${query}`,
    QUERY_MEAL_PLANNER_LOCATIONS
  );
